import { alpha, styled, Typography } from "@mui/material";

import { StyleUtils } from "@/constants/style.utils";

export const BodyText = styled(Typography)(({ theme }) => ({
  fontSize: StyleUtils.fonts.size(3.5),
  color: alpha(theme.palette.text.primary, 0.6),
  textAlign: "center",
})) as typeof Typography;
